/* eslint-disable */
import { Controller } from "react-hook-form";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Typography, TextField, Button } from "@mui/material";

import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import { boxStyle, Grid2, inputStyle, SectionTitle } from "./CommonModule";
import { CustomMuiDateTimePicker } from "components/date_picker/CustomMuiDateTimePicker";
import MaintenanceInputPartsRow from "./MaintenanceInputPartsRow";
import { useTranslation } from "react-i18next";

const MaintenanceCommonForm = ({ mForm }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* <Box sx={{ flex: 1, mt: 2 }}>
        <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.workType')}</Typography>
        <Controller
          control={mForm.control}
          name="workType"
          // 🚀 [추가] 필수 검증 규칙 추가
          rules={{ required: t('message.common.error.text.breakdown.maintenance.cause.select') }}
          render={({ field: { name } }) => (
            <CustomFormEnumSelect
              style={{ minWidth: '96%' }}
              label={t('message.common.subtitle.breakdown.maintenance.cause')}
              isLabelView={false}
              register={mForm.register}
              name={name}
              requiredMessage={t('message.common.error.text.breakdown.maintenance.cause.select')}
              defaultValue={mForm.maintenanceTask && (mForm.maintenanceTask.workType || '')}
              list={[]}
              // list={mForm.getEnumValueByEnumName("EquipmentTrouble")}
            />
          )}
        />
        {mForm.errors.workType && <small role="alert"><br/>{mForm.errors.workType.message}</small>}
      </Box> */}

      <Grid2>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.breakdown.maintenance')} {t('message.common.subtitle.cause')}</Typography>
          <Controller
            control={mForm.control}
            name="trouble"
            // 🚀 [추가] 필수 검증 규칙 추가
            rules={{ required: t('message.common.error.text.breakdown.maintenance.cause.select') }}
            render={({ field: { name } }) => (
              <CustomFormEnumSelect
                style={{ minWidth: '96%' }}
                label={t('message.common.subtitle.breakdown.maintenance.cause')}
                isLabelView={false}
                register={mForm.register}
                name={name}
                requiredMessage={t('message.common.error.text.breakdown.maintenance.cause.select')}
                defaultValue={mForm.maintenanceTask && (mForm.maintenanceTask.trouble || '')}
                list={mForm.getEnumValueByEnumName("EquipmentTrouble")}
              />
            )}
          />
          {mForm.errors.trouble && <small role="alert"><br/>{mForm.errors.trouble.message}</small>}
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.main.management')}</Typography>
          <div style={{ marginTop: "10px" }}>
            <input type="checkbox" id="importantYn" {...mForm.register("importantYn")} />
          </div>
        </Box>
      </Grid2>

      <Grid2>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.maintenance.start.datetime')}</Typography>
          <Controller
            control={mForm.control}
            name="workingBgnAt"
            // 🚀 [추가] 작업 시작일시 필수 규칙 (기본 제공 데이터가 없을 때를 대비)
            rules={{ required: t('msg.enter.maintenance.start.datetime') }}
            render={({ field, fieldState }) => <CustomMuiDateTimePicker field={field} fieldState={fieldState} />}
          />
          {/* {mForm.errors.workingBgnAt && <small role="alert"><br/>{mForm.errors.workingBgnAt.message}</small>} */}
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1.5 }}>
            <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0" }}>{t('message.common.subtitle.work.end.datetime')}</Typography>
            <Button 
              variant="outlined" size="small" onClick={mForm.setEndAtNow}
              sx={{ 
                fontSize: "0.75rem", padding: "2px 8px", minWidth: "auto", color: "#02db02", borderColor: "#02db02",
                "&:hover": { borderColor: "#256a20", backgroundColor: "rgba(48, 138, 42, 0.08)" }
              }}
            >
              NOW
            </Button>
          </Box>
          <Controller
            control={mForm.control}
            name="workingEndAt"
            // 💡 참고: 작업 종료일시는 상황에 따라 공란으로 등록할 수 있으므로 규칙을 비워둡니다.
            render={({ field, fieldState }) => <CustomMuiDateTimePicker field={field} fieldState={fieldState} />}
          />
        </Box>
      </Grid2>

      <Grid2>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.worker')} * </Typography>
          <TextField 
            style={{ width: "90%" }}
            {...mForm.register("worker", { required: t('message.common.error.text.worker.input') })} 
            defaultValue={mForm.name || ''}
            sx={{ ...inputStyle, minWidth: '96%', '& .MuiInputBase-root': { height: '50px' } }}
          />
          {mForm.errors.worker && <small role="alert"><br/>{mForm.errors.worker.message}</small>}
        </Box>
        
        <Box sx={{ flex: 1, marginTop: "5px" }}>
          <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.actionType')} * </Typography>
          <Controller
            control={mForm.control}
            name="type"
            // 🚀 [추가] 조치유형 필수 검증 규칙 추가
            rules={{ required: t('message.common.error.text.actionType.select') }}
            render={({ field: { name } }) => (
              <CustomFormEnumSelect
                style={{ minWidth: '96%' }}
                label={t('message.common.subtitle.actionType')}
                isLabelView={false}
                register={mForm.register}
                name={name}
                requiredMessage={t('message.common.error.text.actionType.select')}
                defaultValue={mForm.maintenanceTask && (mForm.maintenanceTask.type || '')}
                list={mForm.maintenanceTask?.status !== 'O3_C' ? 
                    mForm.getEnumValueByEnumName("MaintenanceType") 
                  : [mForm.getEnumValueByEnumName("MaintenanceType").find(mt=> mt.code === mForm.maintenanceTask?.type)]
                }
              />
            )}
          />
          {mForm.errors.type && <small role="alert"><br/>{mForm.errors.type.message}</small>}
        </Box>
      </Grid2>

      <SectionTitle title={t('message.common.subtitle.breakdown.input.details')} />
      <Box sx={boxStyle}>
        {mForm.inputParts.map((item) => (
          <MaintenanceInputPartsRow
            key={item.id}
            item={item}
            status={mForm.maintenanceTask?.status}
            control={mForm.control}
            register={mForm.register}
            componentOptions={mForm.componentOptions}
            locationOptions={mForm.locationOptions}
            onPartChange={mForm.handlePartChange}
            onDelete={mForm.deleteInputPart}
          />
        ))}
        {mForm.maintenanceTask?.status !== 'O3_C' &&
        <Button fullWidth variant="outlined" sx={{ mt: 2, borderStyle: "dashed" }} onClick={mForm.addInputPart}>
          + {t('message.common.btn.add.detail.set')}
        </Button>
        }
      </Box>

      <Box sx={{ flex: 1, mt: 2 }}>
        <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
          {t('message.common.subtitle.status.report.file')}
          <AddCircleOutlineIcon fontSize="small" style={{ cursor: "pointer", marginLeft: "5px" }} onClick={mForm.addInputFile} />
        </Typography>
        {mForm.inputFiles.map((item, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
            <input type="file" value={''} className="file-input" style={{ width: "200px" }} onChange={e => mForm.handleInputFileChange(e, index)} />
            <RemoveCircleOutlineIcon fontSize="small" style={{ cursor: "pointer", marginLeft: "5px" }} onClick={() => mForm.deleteInputFile(item.id)} />
            {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <span>{item.rFile.name}</span>)}
          </div>
        ))}
      </Box>
      
      <Box style={{ marginBottom: "15px" }}>
        <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.alertDetail')} / {t('message.common.subtitle.work.detail')}</Typography>
        <TextField
          fullWidth multiline rows={4}
          {...mForm.register("remark", { required: t('message.common.error.text.work.detail.input') })} 
          placeholder={t('message.common.text.placeholder.action.result.and.remarks')}
          sx={{ textarea: { color: "#e2e8f0" }, "& .MuiOutlinedInput-root": { backgroundColor: "#0f172a" } }}
        />
        {mForm.errors.remark && <small role="alert"><br/>{mForm.errors.remark.message}</small>}
      </Box>
    </>
  );
};

export default MaintenanceCommonForm;